exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "* {\n  margin: 0px;\n  padding: 0px; }\n\n:host {\n  display: flex;\n  height: 100%; }\n\n:host(.hidden) {\n  display: none; }\n\n.tabs__panel {\n  background-color: #d7d7d7;\n  width: 100%;\n  box-shadow: inset 0px 0px 0px 1px #c9c9c9;\n  border-radius: 6px;\n  padding: 30px 15px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/tabs/tab.component.scss
// module id = 10
// module chunks = 0 1